module.exports = __webpack_public_path__ + "images/favicon-32.598dec77723b6aa710b64727fc47ceba.png";